export const OMISSIS_CONTEXT_KEY = 'omissis-directive@internal';
/**
 * Valore che sostituisce il testo omissis.
 * !ATTENZIONE!
 * Il campo è utilizzato nella EvaluationScope.ts: `isOmissisValue()`
 *
 * In questo modo, se il valore del campo dovesse essere uguale all'omissis, restituisco null
 * nelle operazioni.
 *
 * Non possiamo usare la costante perché l'expression è nel package engine che non
 * ha dipendenze con il package common-web.
 *
 * In caso di modifica di questo valore, ricordarsi di aggiornare il valore.
 */
export const OMISSIS_REPLACE_TEXT = '******';
